import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppVersionState, RootState } from 'types/state'

const initialState: AppVersionState = {
  currentPipelineVersion: 0,
  lastPipelineVersion: 0,
}

export const appVersionSlice = createSlice({
  name: 'app-version',
  initialState,
  reducers: {
    setLastPipelineVersion: (state: AppVersionState, action: PayloadAction<number>) => {
      state.lastPipelineVersion = action.payload
    },
    setCurrentPipelineVersion: (state: AppVersionState, action: PayloadAction<number>) => {
      state.currentPipelineVersion = action.payload
    },
  },
})

export const { setLastPipelineVersion, setCurrentPipelineVersion } = appVersionSlice.actions

export const appVersionSelectors = {
  isUpdateAvailable: (state: RootState) =>
    state.appVersionState.lastPipelineVersion > state.appVersionState.currentPipelineVersion,
  lastPipelineVersion: (state: RootState) => state.appVersionState.lastPipelineVersion,
  currentPipelineVersion: (state: RootState) => state.appVersionState.currentPipelineVersion,
}

export const appVersionActions = {
  setLastPipelineVersion,
  setCurrentPipelineVersion,
}

export default appVersionSlice.reducer
